import { Button, Tooltip, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';

const useStyles = makeStyles(theme => (createStyles({
  root: {
    marginLeft: '7px',
    height: 35,
    boxShadow: 'none'
  },
})));

interface ICustomButtonProps {
  tooltip: NonNullable<React.ReactNode>,
  onClick: (event: any) => void,
  disabled?: boolean,
  className?: string,
  internalButtonClassName?: string;
  color?: "inherit" | "primary" | "secondary" | "default" | undefined;
}

const CustomButton: React.FC<ICustomButtonProps> = ({ children, internalButtonClassName, color, className, onClick, tooltip, disabled }) => {
  const cssClasses = useStyles({});

  return (
    <Typography className={className} variant="h4">
      <Tooltip title={tooltip}>
        <span>
          <Button className={`${cssClasses.root} ${internalButtonClassName}`} variant="contained" size="small" color={color} onClick={onClick} disabled={disabled} >
            {children}
          </Button>
        </span>
      </Tooltip>
    </Typography>
  );
};

CustomButton.defaultProps = {
  disabled: false,
  color: "primary"
} as Partial<ICustomButtonProps>;

export default CustomButton;
